import { I18n } from "../services/I18n";
import "./generated/site-translations-cs";
import common_cs from "../../../../../libs/ps/restaumatic-common/locales/cs.json";
import core_types_sites_cs from "../../../../../libs/ps/restaumatic-core-types-sites/locales/cs.json";
I18n.translations = I18n.translations || {};
I18n.translations = I18n.extend(I18n.translations, {
  cs: { _core_types_sites: core_types_sites_cs },
});
I18n.translations = I18n.extend(I18n.translations, {
  cs: { _common: common_cs },
});
